export var UiLogLevel;
(function (UiLogLevel) {
    UiLogLevel[UiLogLevel["FATAL"] = 1] = "FATAL";
    UiLogLevel[UiLogLevel["ERROR"] = 2] = "ERROR";
    UiLogLevel[UiLogLevel["WARN"] = 3] = "WARN";
    UiLogLevel[UiLogLevel["INFO"] = 4] = "INFO";
    UiLogLevel[UiLogLevel["DEBUG"] = 5] = "DEBUG";
    UiLogLevel[UiLogLevel["ALL"] = 6] = "ALL";
})(UiLogLevel || (UiLogLevel = {}));
export class ConsoleLogger {
    constructor(loggingLevel) {
        this.loggingLevel = loggingLevel;
    }
    error(message, ...optionalParams) {
        if (this.loggingLevel >= 1) {
            console.error(message, ...optionalParams);
        }
    }
    warn(message, ...optionalParams) {
        if (this.loggingLevel >= 3) {
            console.warn(message, ...optionalParams);
        }
    }
    info(message, ...optionalParams) {
        if (this.loggingLevel >= 4) {
            console.info(message, ...optionalParams);
        }
    }
    infoTrace(title, ...optionalParams) {
        if (this.loggingLevel >= 4) {
            console.groupCollapsed(title);
            console.log(...optionalParams);
            console.trace();
            console.groupEnd();
        }
    }
    debug(message, ...optionalParams) {
        if (this.loggingLevel >= 5) {
            console.debug(message, ...optionalParams);
        }
    }
    log(message, ...optionalParams) {
        if (this.loggingLevel >= 6) {
            console.log(message, ...optionalParams);
        }
    }
}
ConsoleLogger.getInstance = (loggingLevel) => {
    if (!ConsoleLogger.instance || loggingLevel !== ConsoleLogger.instance.loggingLevel) {
        ConsoleLogger.instance = new ConsoleLogger(loggingLevel);
        ConsoleLogger.instance.loggingLevel = loggingLevel;
    }
    return ConsoleLogger.instance;
};
const defaultLevel = 3;
export const defaultLogLevel = defaultLevel;
